import { render, staticRenderFns } from "./ModattaSideModalNewOfferPreview.vue?vue&type=template&id=8a8ee576"
import script from "./ModattaSideModalNewOfferPreview.vue?vue&type=script&lang=js"
export * from "./ModattaSideModalNewOfferPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports